import styled from 'styled-components';
import { COLOR, FONT_SIZE, RADIUS, SPACING } from '../../../constants/theme';

export const Compare = styled.div`
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  gap: ${SPACING.md};
  margin-bottom: ${SPACING.md};
`;

export const CompareSide = styled.div`
  padding: ${SPACING.md};
  border-radius: ${RADIUS.md};
  background: ${({ highlight }) =>
    highlight ? COLOR.primaryLight : COLOR.mutedBackground};
`;

export const CompareLabel = styled.div`
  font-size: ${FONT_SIZE.sectionTitle};
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: ${COLOR.textMuted};
`;

export const CompareValue = styled.div`
  margin-top: 4px;
  font-size: ${FONT_SIZE.body};
  font-weight: 600;
  line-height: 1.4;
  color: ${COLOR.navy};
  text-decoration: ${({ struck }) => (struck ? 'line-through' : 'none')};
`;

export const CompareArrow = styled.span`
  font-size: 18px;
  color: ${COLOR.textMuted};
`;
